module.exports = __webpack_public_path__ + "img/tutorial-thumbnail-03.1e7dca78.jpg";